// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__25ST_","label":"Completed_label__2JJwV"};